import { Box } from "@material-ui/core";
import React from "react";
import { CorpSessionInfo, SessionInfo } from "redmond";
import AdminHomePageSection from "../AdminHomePageSection/component";
import ValuePropCarousel from "../ValuePropCarousel";

interface CorpHomePageBottomSectionProps {
  sessionInfo: SessionInfo | CorpSessionInfo;
}

export const CorpHomePageBottomSection = ({
  sessionInfo,
}: CorpHomePageBottomSectionProps) => (
  <Box>
    <ValuePropCarousel />
    <AdminHomePageSection sessionInfo={sessionInfo} />
  </Box>
);
